import { GroupType } from '@kcftech/prometheus-client';
import { Subtree } from 'pages/workbench/side_panel/workbench_tree/useLoadSubtree';

export const parentIsSubSystem = (treeItem: Subtree) =>
    treeItem.parent?.TreeItemType === GroupType.Group;
